"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    CARD_CONSENT_UPDATED_EVENT: true
};
exports.CARD_CONSENT_UPDATED_EVENT = void 0;
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _defaultTranslations[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _defaultTranslations[key];
        }
    });
});
var _constantsGenerated = require("../constants-generated");
Object.keys(_constantsGenerated).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _constantsGenerated[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _constantsGenerated[key];
        }
    });
});
/** Event name used ATM for notifying checkout summary about state changes. */ const CARD_CONSENT_UPDATED_EVENT = exports.CARD_CONSENT_UPDATED_EVENT = 'card-consent-updated';
